import { useState, useEffect } from "react";
import Logo from "../../assets/img/NewsImgs/newLogo.webp"
import Person from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson"
import Text from "../../assets/icon/NewsIcons/MainAdmin/NewsText"
import Group from "../../assets/icon/NewsIcons/MainAdmin/NewsGroup"
import Camera from "../../assets/icon/NewsIcons/MainAdmin/NewsCamera"
import Share from "../../assets/icon/NewsIcons/MainAdmin/NewsShare"
import Visit from "../../assets/icon/NewsIcons/MainAdmin/VisitChart"
import Guide from "../../assets/icon/NewsIcons/MainAdmin/NewsGuide"
import Exit from "../../assets/icon/NewsIcons/MainAdmin/NewsExit"
import Down from "../../assets/icon/NewsIcons/MainAdmin/NewsDown3"
import Up from "../../assets/icon/NewsIcons/MainAdmin/NewsUp3"
import { Link, useLocation } from "react-router-dom"; 
import Cookies from 'universal-cookie';

const MainAdminSidebar = () => {

    const [news, setNews] = useState(false);
    const [text, setText] = useState(false);
    const [admin, setAdmin] = useState();
    const location = useLocation();
    const isActiveLink = (path) => location.pathname === path;
    const NewsClick = () => {
        if (news === false) {
            setNews(true);
        } else {
            setNews(false);
        }
    }
    const TextClick = () => {
        if (text === false) {
            setText(true);
        } else {
            setText(false);
        }
    }
    useEffect(() => {
        const cookies = new Cookies();
        setAdmin(cookies.get('role'));
    }, []);
    const signOut =async () => {
        const cookies = new Cookies();
        await   cookies.remove("role")
        await cookies.remove("token")
        await cookies.remove("name")
    }
    return (
        <div className="w-[295px] h-[1180px] rounded-l-[50px] bg-white shadow-sidbar-shadow">
            <div className=" py-[20px] flex justify-center border-b-2 border-borderGray">
                <Link to={"/"}>
                <img src={Logo} className="w-[120px]" />
                </Link>
            </div>
            <div className="p-[30px]">
                {
                    admin === "Admin" ?
                        <>
                            <Link to={"/mainAdmin/users"} className={`flex justify-start items-center mb-[28px] `}   >
                                <div><Person color={'#184548'} /></div>
                                <span className={`text-[15px] font-IRANYekanBold mr-[15px] text-mainColor2 hover:text-nextColor ${isActiveLink("/mainAdmin/users") ? 'text-nextColor' : 'text-mainColor2'}`}>ادمین ها</span>
                            </Link>
                            <Link to={"/mainAdmin/writers"} className="flex justify-start items-center mb-[28px]"   >
                                <div><Person color={'#184548'} /></div>
                                <span className={`text-[15px] font-IRANYekanBold mr-[15px] text-mainColor2 hover:text-nextColor ${isActiveLink("/mainAdmin/writers") ? 'text-nextColor' : 'text-mainColor2'}`}>نویسندگان </span>
                            </Link>
                            
                        </>
                        :
                        null
                }
                <button onClick={NewsClick} className={`flex w-full justify-between items-center ${news ? 'mb-[16px]' : 'mb-[28px]'} `}>
                    <div className="flex justify-start items-center">
                        <div><Text /></div>
                        <p className="text-[15px] font-IRANYekanBold mr-[15px] text-mainColor2 hover:text-nextColor">اخبار </p>
                    </div>
                    {news === false ?
                        <div><Down /></div>
                        :
                        <div><Up /></div>
                    }
                </button>
                {news === false ?
                    <div></div>
                    :
                    <div>
                        <Link to={"/mainAdmin/newsPendingConfirmation"} className="flex justify-start items-center mb-[16px]">
                            <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/newsPendingConfirmation") ? 'text-nextColor' : 'text-mainColor2'}`}>اخبار در انتظار تایید </p>
                        </Link>
                        <Link to={"/mainAdmin/PublishedNewses"} className="flex justify-start items-center mb-[16px]"   >
                            <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/PublishedNewses") ? 'text-nextColor' : 'text-mainColor2'}`}>اخبار منتشر شده</p>
                        </Link>
                        <Link to={"/mainAdmin/rejectedNewses"} className="flex justify-start items-center mb-[16px]"   >
                            <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/rejectedNewses") ? 'text-nextColor' : 'text-mainColor2'}`}>اخبار رد شده</p>
                        </Link>
                        <Link to={"/mainAdmin/ScheduledNews"} className="flex justify-start items-center mb-[16px]"   >
                            <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/ScheduledNews") ? 'text-nextColor' : 'text-mainColor2'}`}>اخبار در صف انتشار</p>
                        </Link>
                        <Link to={"/mainAdmin/uploadNews/release"} className="flex justify-start items-center mb-[16px]"   >
                            <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/uploadNews/release") ? 'text-nextColor' : 'text-mainColor2'}`}>بارگزاری خبر جدید</p>
                        </Link>
                    </div>
                }
                {
                    admin === "Admin" ?
                        <>
                            <Link to={"/mainAdmin/newsCategory/add"} className={`flex justify-start items-center ${news ? 'mt-[28px]' : 'mt-[0px]'} mb-[28px]`}   >
                                <div><Group color={'#184548'} /></div>
                                <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/newsCategory/add") ? 'text-nextColor' : 'text-mainColor2'}`}>دسته بندی اخبار  </p>
                            </Link>
                            <Link to={"/mainAdmin/tagsCategory/add"} className={`flex justify-start items-center ${news ? 'mt-[28px]' : 'mt-[0px]'} mb-[28px]`}   >
                                <div><Group color={'#184548'} /></div>
                                <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/tagsCategory/add") ? 'text-nextColor' : 'text-mainColor2'}`}>برچسب های اخبار</p>
                            </Link>

                            <Link to={"/mainAdmin/definitionAdvertising"} className="flex justify-start items-center mb-[28px]"   >
                                <div><Camera color={'#184548'} /></div>
                                <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/definitionAdvertising") ? 'text-nextColor' : 'text-mainColor2'}`}>تعریف تبلیغات </p>
                            </Link>
                            <Link to={"/mainAdmin/indicators"} className="flex justify-start items-center mb-[28px]"   >
                                <div><Group color={'#184548'} /></div>
                                <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/indicators") ? 'text-nextColor' : 'text-mainColor2'}`}>شاخص‌های اقتصادی و قیمت کالاهای اساسی</p>
                            </Link>
                            <Link to={"/mainAdmin/socialNetworks"} className="flex justify-start items-center mb-[28px]"   >
                                <div><Share color={'#184548'} /></div>
                                <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/socialNetworks") ? 'text-nextColor' : 'text-mainColor2'}`}>شبکه های اجتماعی </p>
                            </Link>
                            <Link to={"/mainAdmin/visits"} className="flex justify-start items-center mb-[28px]"   >
                                <div><Visit color={'#184548'} /></div>
                                <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/visits") ? 'text-nextColor' : 'text-mainColor2'}`}>بازدید ها</p>
                            </Link>
                            <button onClick={TextClick} className={`flex w-full justify-between items-center ${text ? 'mb-[16px]' : 'mb-[28px]'} `}>
                                <div className="flex justify-start items-center">
                                    <div><Text /></div>
                                    <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 `}>متن ها </p>
                                </div>
                                {text === false ?
                                    <div><Down /></div>
                                    :
                                    <div><Up /></div>
                                }
                            </button>
                            {text === false ?
                                <div></div>
                                :
                                <div>
                                    <Link to={"/mainAdmin/aboutUs"} className="flex justify-start items-center mb-[16px]"   >
                                        <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/aboutUs") ? 'text-nextColor' : 'text-mainColor2'}`}>صفحه ی درباره ی ما</p>
                                    </Link>
                                    <Link to={"/mainAdmin/contactUs"} className="flex justify-start items-center mb-[16px]"   >
                                        <p className={`text-[15px] font-IRANYekanBold mr-[15px] hover:text-nextColor text-mainColor2 ${isActiveLink("/mainAdmin/contactUs") ? 'text-nextColor' : 'text-mainColor2'}`}>صفحه ی تماس با ما</p>
                                    </Link>
                                </div>
                            }
                        </>
                        :
                        null}
                <Link to={"/"} className={`flex justify-start items-center ${text ? 'mt-[28px]' : 'mt-[0px]'} mb-[28px]`}   >
                    <div><Guide /></div>
                    <p className={`text-[15px] font-IRANYekanBold mr-[15px] text-mainColor2 hover:text-nextColor ${isActiveLink("/") ? 'text-nextColor' : 'text-mainColor2'}`}>راهنمای سامانه </p>
                </Link>
                <Link to={"/admin"} onClick={()=>signOut()} className="flex justify-start items-center mb-[28px]"   >
                    <div><Exit /></div>
                    <p className="text-[15px] font-IRANYekanBold mr-[15px] text-mainColor2 hover:text-nextColor">خروج از سامانه </p>
                </Link>

            </div>

        </div>
    )
}

export default MainAdminSidebar;